import RestService from './_private/RestService';
import { getConfig } from '@superbet-group/web.lib.config';

export default class FreeToPlayService {
    private restService: RestService;

    constructor() {
        this.restService = new RestService();
    }

    getAccessToken() {
        return this.restService.getAccessToken();
    }

    launchGame(sessionId: string, gameId: string) {
        return this.restService.launchGame(sessionId, gameId, getConfig().appLocale.locale);
    }
}
